import { render, staticRenderFns } from "./ed-homework-student-list-item.vue?vue&type=template&id=1ecc7162&scoped=true&"
import script from "./ed-homework-student-list-item.ts?vue&type=script&lang=js&"
export * from "./ed-homework-student-list-item.ts?vue&type=script&lang=js&"
import style0 from "./ed-homework-student-list-item.scss?vue&type=style&index=0&id=1ecc7162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc7162",
  null
  
)

export default component.exports